import { useId } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useVzhlad } from "../../context/VzhladContext";
import "./VzhladPrepinac.scss";

export const MOZNOSTI = [
  { volba: "light", label: "Svetlý", Ikona: Sun },
  { volba: "dark", label: "Tmavý", Ikona: Moon },
  { volba: "auto", label: "Auto", Ikona: Monitor, title: "Podľa nastavenia zariadenia" },
];

/**
 * Výber svetlého / tmavého režimu — obsah okienka VzhladTlacidlo.
 * Okienko po kliknutí ostáva otvorené — výsledok vidno hneď a dá sa skúsiť
 * aj druhá možnosť.
 */
function VzhladPrepinac() {
  const { volba, nastavVolbu } = useVzhlad();
  const nadpisId = useId();

  return (
    <div className="vzhlad-prepinac">
      <span className="vzhlad-prepinac__nadpis" id={nadpisId}>
        Vzhľad
      </span>
      <div className="vzhlad-prepinac__volby" role="radiogroup" aria-labelledby={nadpisId}>
        {MOZNOSTI.map(({ volba: v, label, Ikona, title }) => (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={volba === v}
            title={title}
            className={`vzhlad-prepinac__volba${volba === v ? " vzhlad-prepinac__volba--aktivna" : ""}`}
            onClick={() => nastavVolbu(v)}
          >
            <Ikona size={14} aria-hidden="true" />
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default VzhladPrepinac;
